import { ReactNode } from 'react';
import './index.css';

interface Props {
	title: ReactNode;
	options: Option[];
	onToggleSelectAll?: (updatedOptions: Option[]) => void;
}

interface Option {
	label: any;
	value: any;
	selected: boolean;
}

const PPDropDownMultiSelect: React.FC<Props> = (props) => {
	const { title, options, onToggleSelectAll } = props;

	const allSelected = options.every(option => option.selected);

	const handleToggle = () => onToggleSelectAll && onToggleSelectAll(
		options.map(o => ({ ...o, selected: !allSelected }))
	);

	return (
		<div className="ppdropdown-tools">
			<div className="ppdropdown-tools-title">{title}</div>
			<div className="ppdropdown-tools-button-container">
				<button className="ppdropdown-tools-button" onClick={handleToggle}>
					{allSelected ? 'Remover tudo' : 'Selecionar tudo'}
				</button>
			</div>
		</div>
	);
};

export default PPDropDownMultiSelect;